/** @format */

import axios from "axios";
import swal from "sweetalert";
import { NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";

import {
  DeleteOutlined,
  SaveOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { header } from "../../../../components/api/Header";
import { user_data } from "../../../../components/functions/usr";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

function Add({ date, setDate }) {
  const [data, setData] = useState("");
  const [ldate, setLdate] = useState(date);
  const [changed, setChanged] = useState(false);
  const [loading, setLoading] = useState(false);

  if (user_data()) {
    if (user_data().region_id == 7) {
      console.log("ok");
    } else {
      window.location = "/reykauchqurgon";
    }
  } else {
    window.location = "/reykauchqurgon";
  }

  useEffect(() => {
    const fetchDate = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/reka02/daily?date=" +
            date,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan aloqa yo'q");
      } finally {
        setLoading(false);
      }
    };
    if (date) {
      fetchDate();
    }
  }, [date]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  const setHandler = (v, t, s) => {
    let d = { ...data };
    if (t === "tashlama") {
      d["tashlama"][s] = v;
    }
    if (t === "reka") {
      d["reka"][s] = v;
    }
    setChanged(true);
    setData(d);
  };

  const doIt = async (action) => {
    const res = await axios
      .post(
        getEnv('REACT_APP_BASE_URL') + "/v1/region/reka02/" + action,
        { date, data },
        header()
      )
      .catch((e) => {
        console.log("Xato", e);
        alert("Server bilan aloqa yo'q!");
      });
    if (res) {
      if (res.data.status == 200) {
        swal("Muvaffaqiyatli", res.data.message, "success");
        setDate("");
        window.location = "/reykauchqurgon";
      } else {
        swal("Xato", res.data.message, "error");
      }
    }
  };

  const deletehandler = () => {
    let xa = window.confirm(
      date + " dagi ma'lumotlarni o'chirishni xoxlaysizmi?"
    );
    if (xa) {
      doIt("delete");
    }
  };

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <ul className='list-unstyled list-inline'>
            <li className='list-inline-item'>
              <NavLink
                to='/reykauchqurgon'
                className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                <ArrowLeftOutlined />
                &nbsp;&nbsp;&nbsp;Qaytish
              </NavLink>
            </li>

            <li className='list-inline-item'>
              {data ? (
                data["id"] != 0 ? (
                  <button
                    className='btn btn-sm btn-outline-danger d-flex align-items-center'
                    onClick={() => deletehandler()}>
                    O'chirish&nbsp;&nbsp;&nbsp;
                    <DeleteOutlined />
                  </button>
                ) : null
              ) : null}
            </li>

            <li className='list-inline-item'>
              <div className='d-flex'>
                <input
                  type='date'
                  className='form-control-sm form-control'
                  onChange={(e) => setLdate(e.target.value)}
                  value={ldate}
                />
              </div>
            </li>

            <li className='list-inline-item'>
              {date ? null : " <--Sanani tanlang"}
            </li>
          </ul>
        </div>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead' id='tableFlexible'>
          <table className='table table-bordered table-style' id='tblData'>
            <thead>
              <tr>
                <th scope='col'>02 Reyka</th>
                <th scope='col'>1</th>
                <th scope='col'>2</th>
                <th scope='col'>3</th>
                <th scope='col'>4</th>
                <th scope='col'>5</th>
                <th scope='col'>6</th>
                <th scope='col'>7</th>
                <th scope='col'>8</th>
                <th scope='col'>9</th>
                <th scope='col'>10</th>
                <th scope='col'>11</th>
                <th scope='col'>12</th>
                <th scope='col'>13</th>
                <th scope='col'>14</th>
                <th scope='col'>15</th>
                <th scope='col'>16</th>
                <th scope='col'>17</th>
                <th scope='col'>18</th>
                <th scope='col'>19</th>
                <th scope='col'>20</th>
                <th scope='col'>21</th>
                <th scope='col'>22</th>
                <th scope='col'>23</th>
                <th scope='col'>24</th>
              </tr>
            </thead>

            {date ? (
              <tbody>
                <tr>
                  <th>Reyka, sm</th>
                  {Array(24)
                    .fill()
                    .map((_, ind) => {
                      return (
                        <th key={ind} className='inserttr'>
                          <input
                            className='insertable'
                            type='number'
                            value={
                              data["reka"]
                                ? data["reka"][ind + 1]
                                  ? data["reka"][ind + 1]
                                  : ""
                                : ""
                            }
                            onChange={(e) =>
                              setHandler(e.target.value, "reka", ind + 1)
                            }
                          />
                        </th>
                      );
                    })}
                </tr>

                <tr>
                  <th className='fix-with'>
                    Tashlama, m<sup>3</sup>/s
                  </th>

                  {Array(24)
                    .fill()
                    .map((_, ind) => {
                      return (
                        <th key={ind} className='inserttr'>
                          <input
                            className='insertable'
                            type='number'
                            value={
                              data["tashlama"]
                                ? data["tashlama"][ind + 1]
                                  ? data["tashlama"][ind + 1]
                                  : ""
                                : ""
                            }
                            onChange={(e) =>
                              setHandler(e.target.value, "tashlama", ind + 1)
                            }
                          />
                        </th>
                      );
                    })}
                </tr>
              </tbody>
            ) : null}
          </table>

          {changed ? (
            <button
              className='btn btn-sm btn-primary d-flex align-items-center'
              onClick={() => doIt("save")}>
              <SaveOutlined /> &nbsp;&nbsp;&nbsp;Saqlash
            </button>
          ) : null}
        </div>
      )}
    </>
  );
}

export default Add;
